// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUY_BUTTON_USED_STROLLERS = "Pozri ponuku jazden\u00fdch ko\u010d\u00edkov";
export const BUY_IN_ESHOP = "K\u00fapi\u0165 v eshope ";
export const GREAT_SET = "V\u00ddHODN\u00dd SET";
export const ORIGINAL_PRICE = "P\u00f4vodne ";
export const SHOPPING_WITH_MK = "Nakupuj s Modr\u00fdm kon\u00edkom";
export const YOU_SAVE = "U\u0161etr\u00ed\u0161";
